/* ============================================================
   ÉKO '77 — EVENT CATERING, THE QUOTE FORM

   What the reference's inline script does on
   eko77-redesign.pages.dev/event-catering/#quote, minus the mock:

     · every [data-quote] button on the page lands on the one form, and a
       package tile that carries data-package pre-selects that package;
     · the form is scrolled to and, on a desktop, the first field takes focus;
     · a date in the past is never an event we can cater, so the date input's
       min is today;
     · a button never keeps focus after a click.

   THE HOOKS ALREADY EXISTED. x-ec-hero, snippets/x-pack-tier (rendered by
   x-ec-packages) and x-ec-close all ship <a href="#quote" data-quote>, the
   tiles adding data-package="Celebrations — up to 50 guests". None of those
   files changes; this script is the other half of a contract they wrote first.
   Because they are ANCHORS and not the reference's bare <button>s, everything
   here is an enhancement: with this file blocked the links still reach the
   form, they simply do not pre-select a package.

   TWO PLACES THIS IS NOT THE REFERENCE, both because there is a server now:
     · the reference toggles a "sent" panel in the browser. Here Shopify
       redirects and sections/x-ec-quote.liquid renders that panel from
       form.posted_successfully?, so a [data-quote] click while the panel is up
       cannot "reset" anything in the DOM — it navigates to the section's own
       again-href instead (this page, without the post-back query), which is
       the same thing the visitor gets from the panel's own button.
     · the reference validates with form.reportValidity(), i.e. the browser's
       bubbles. This paints the message in the field's own error line instead,
       exactly as assets/x-ct-ask.js does for the contact card — the two ÉKO
       forms should not answer an empty field in two different ways.

   EVERYTHING IS DELEGATED FROM document — no per-instance wiring, so a section
   dropped in by the theme editor (shopify:section:load) works with no re-init,
   and two quote forms on one page cannot collide.
   ============================================================ */

(function () {
  'use strict';

  var SECTION = '[data-x-ec-quote]';
  var FORM = '.x-ec-quote__form';
  var FIELD = '.x-ec-quote__fld';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- validation ------------------------------------ */

  function mark(input, bad) {
    var field = input.closest(FIELD);
    if (!field) return;
    field.classList.toggle('is-bad', bad);
    input.setAttribute('aria-invalid', bad ? 'true' : 'false');
  }

  /* empty is invalid; a filled email must also look like one. `novalidate`
     only silences the browser's UI — validity is still computed. */
  function isBad(input) {
    if (input.disabled) return false;
    if (!input.required) return false;
    if (!input.value.trim()) return true;
    return input.validity ? input.validity.typeMismatch : false;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest ? event.target.closest(FORM) : null;
    if (!form) return;

    var first = null;

    form.querySelectorAll('input[required]').forEach(function (input) {
      var bad = isBad(input);
      mark(input, bad);
      if (bad && !first) first = input;
    });

    if (first) {
      event.preventDefault();
      first.focus();
      if (typeof first.scrollIntoView === 'function') {
        first.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
      }
    }
  });

  /* the moment the visitor answers the complaint, drop it */
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.closest || !input.closest(FORM)) return;
    var field = input.closest(FIELD);
    if (field && field.classList.contains('is-bad') && !isBad(input)) mark(input, false);
  });

  /* ---------- the package a button arrived with -------------- */

  /* The reference matches on the FIRST WORD of data-package, so a tile renamed
     in the theme editor still finds its radio as long as the name still starts
     the value. An exact match is tried first — it is the common case and it
     cannot mis-hit two packages whose names share a first word. */
  function setPackage(section, wanted) {
    var radios = section.querySelectorAll('input[data-x-ec-pkg]');
    if (!radios.length) return;

    var want = (wanted || '').trim().toLowerCase();
    var head = want.split(' ')[0];
    var hit = null;

    radios.forEach(function (radio) {
      var value = radio.value.trim().toLowerCase();
      var match = !!want && (value === want || (!!head && value.indexOf(head) === 0));
      radio.checked = match;
      if (match) hit = radio;
    });

    return hit;
  }

  /* ---------- every "Request a quote" on the page ------------ */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-quote]') : null;
    if (!trigger) return;

    /* the anchor may point at another page's form — leave those alone */
    var href = trigger.getAttribute('href') || '';
    var anchor = href.charAt(0) === '#' ? href.slice(1) : '';
    var section = anchor ? document.getElementById(anchor) : document.querySelector(SECTION);
    if (!section || !section.matches(SECTION)) return;

    event.preventDefault();
    if (trigger.blur) trigger.blur();

    /* the card is showing the sent panel: there is no form to pre-fill, so go
       and fetch a fresh one — the panel's own button goes to the same place */
    if (section.querySelector('.x-ec-quote__sent')) {
      var again = section.getAttribute('data-x-ec-quote-again');
      if (again) {
        window.location.href = again;
        return;
      }
    }

    if (trigger.hasAttribute('data-package')) {
      setPackage(section, trigger.getAttribute('data-package'));
    }

    section.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

    /* on a phone the keyboard would cover the form it just scrolled to */
    var firstField = section.querySelector(FORM + ' input[type="date"]');
    if (firstField && window.innerWidth > 900) {
      window.setTimeout(function () {
        firstField.focus({ preventScroll: true });
      }, reduced ? 0 : 520);
    }
  });

  /* a button must not keep focus after a click — the reference does this for
     every button on the page; scoped here to the ones this section owns */
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest(SECTION + ' button') : null;
    if (button && button.blur) button.blur();
  });

  /* ---------- a date in the past is never an event ----------- */

  /* Set here rather than in Liquid on purpose: Shopify serves pages from a
     full-page cache, so a `min` rendered server-side could be yesterday's. */
  function seedDates(root) {
    var now = new Date();
    var today =
      now.getFullYear() +
      '-' +
      ('0' + (now.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + now.getDate()).slice(-2);

    (root || document).querySelectorAll(SECTION + ' input[type="date"]').forEach(function (input) {
      if (!input.getAttribute('min')) input.setAttribute('min', today);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      seedDates();
    });
  } else {
    seedDates();
  }

  document.addEventListener('shopify:section:load', function (event) {
    seedDates(event.target);
  });
})();
